
import util from '@/utils/util';

export function setBtnAreaConfig() {
  return [
    {label: ()=> {return '搜索'}, type: 'primary', bindClick: ()=>{this.getListCX()}, setPower: () => {return true}},
    {label: ()=> {return '重置'}, type: 'primary', bindClick: ()=>{this.resetForm('filters')}, setPower: () => {return true}},
    {label: ()=> {return '新增'}, type: 'primary', bindClick: ()=>{this.goForm('add')}, setPower: () => {return true}},
  ]
}
export function setTableConfig() {
	return {
    label: ['Pileline名称', '运行实例主机地址', 'Route数量', '创建时间', '创建人', '操作'],
    prop: ['name', 'executorHost', 'routeNum', 'createTime', 'creatorName','active'],
    custom: [
      {prop: 'routeNum', width:100},
      {prop: 'creatorName', width: 200},
      {
        prop: 'createTime',
        width: 200,
        customType: 'custom-dom',
        customRender: (scope) => {
          return `<div>${scope.row.createTime.replace(/T/g,' ')}</div>`
        }
      },
      {
        prop: 'active',
        customType: 'table-btn',
        customBtnList: [
          {
            render: () => { if(this.tableData.length > 0) return '详情' },
            customBindClick: (scope) => {this.goForm('details', scope.row.id)}
          },
          {
            render: () => '修改',
            customBindClick: (scope) => {this.goForm('edit',scope.row.id)}
          },
          {
            render: () => '删除',
            customBindClick: (scope) => {this.del(scope.row.id)}
          }
        ]
      },
    ]
  }
}
